import type {Species} from '@/domain/entities/Species';
import type {SpecieDto} from './SpecieDto';

const SPECIES_COLOR_MAP: Record<number, string> = {
  21: '#4380ae',
  26: '#6db500',
  64: '#b5a600',
  61: '#b54b00',
  28: '#ae43a5',
};

const getRandomColor = () =>
  `#${Math.floor(Math.random() * 16777215)
    .toString(16)
    .padStart(6, '0')}`;

export const toDomain = (dto: SpecieDto): Species => ({
  ...dto,
  color: SPECIES_COLOR_MAP[dto.xorforId] ?? getRandomColor(),
});
